module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p8"
  }, [_vm._v("Dedicado a las madres y a sus hijos.")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Trystan, Kewyin, sois mis chicos")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("y yo vuestra madre, y")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("eso nunca, jamás cambiará.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0d7b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005.vue
// module id = 66
// module chunks = 0